import { render, staticRenderFns } from "./viewMenu.vue?vue&type=template&id=2e3fb1b7"
import script from "./viewMenu.vue?vue&type=script&lang=js"
export * from "./viewMenu.vue?vue&type=script&lang=js"
import style0 from "./viewMenu.vue?vue&type=style&index=0&id=2e3fb1b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports